import { useMemo } from 'react';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useGetOne, useRecordContext } from 'react-admin';
import { Order } from 'types/embedded/order';
import { formatInputInTz } from 'utils/date';

export const useGetOrderCopyMainData = () => {
  const record = useRecordContext<Order>();
  const translate = useTypedTranslate();

  const { data: direction } = useGetOne(
    'directions',
    { id: record?.direction },
    { enabled: !!record },
  );

  const valuesMap: Record<string, { label: string; value: Order[keyof Order] | null | undefined }> =
    useMemo(() => {
      return {
        originId: {
          label: translate('app.filter.idKubera'),
          value: record?.originId,
        },
        merchantReference: {
          label: translate('app.filter.idMerchant'),
          value: record?.merchantReference,
        },
        providerReferenceId: {
          label: translate('app.filter.idProvider'),
          value: record?.providerReferenceId,
        },
        createdAt: {
          label: translate('app.table.creationTime'),
          value: record?.createdAt
            ? formatInputInTz(record.createdAt, { format: 'dd/MM/yyyy HH:mm' })
            : null,
        },
        status: {
          label: translate('app.table.status'),
          value: record?.status?.description,
        },
        amount: {
          label: translate('app.table.amount'),
          value: record?.amount,
        },
        currency: {
          label: translate('app.table.currency'),
          value: record?.currency?.alphaCode,
        },
        direction: {
          label: translate('app.table.direction'),
          value: direction?.description,
        },
      };
    }, [direction, record, translate]);

  const copyData = record
    ? Object.values(valuesMap).reduce((acc, { value, label }) => {
        return value ? acc + `${label}: ${value}\n` : acc;
      }, '')
    : '';

  return { copyData };
};
